/**
 * Sign in snippet
 *
 * @author Mautilus s.r.o.
 * @class Snippet_Search
 * @extends Snippet
 */

Snippet_Search = (function(Snippet) {

	var Snippet_Search = function() {
		this.construct.apply(this, arguments);
	};

	$.extend(true, Snippet_Search.prototype, Snippet.prototype, {
		/**
		 * @inheritdoc Snippet#init
		 */
		init: function(parent, config){
			this.$lastFocused = null;

			this.$searchlEl = this.$el.find('.search-input');

			this.$errorContainer = $('#error-container', this.$el);
			this.errorField = [];

            this.searchInput = this.initInput(this.$searchlEl.find('.input-holder'), __('search_title'));
            $('#stecla54').text(__('spacebar'));
            $('#stecla60').text('« ' + __('go_back_catalog'));
            $('#stecla65').text(__('search_title') + ' »');
            var searchVar = '';
            
            var symbolFlag = 0;
            var searchData = null;

			Keyboard.on('exit', function() {
				this.$el.find('.input-holder').removeClass('typing');
			}, this);
		},

		/**
		 * prepare relevant divs for inputs and keyboard
		 *
		 * @private
		 *
		 * @param {Object} jQuery element where should be input
		 * @param {String} placeholder text
		 * @param {Boolean} hidden if true input is password style with *
		 * @returns Input object
		 */
		initInput: function($el, placeholder, hidden){
			var refObj = new Input('font-size: 22px; font-family: Conv_gestareg;',
      {
				placeHolder: placeholder,
				placeHolderFontSize: '22px',
				cursorBorderColor: '#5e5e5e',
				color: '#fff',
				centered: false,
				fontSize: '22px'
			});
			if(hidden){
				refObj.setPasswordMode(); //turn on password mode
			}
			refObj.create($el);
			refObj.blur();
			return refObj;
		},

		/**
		 * @inheritdoc Snippet#create
		 */
		create: function() {
			if(this.config.$el) {
				return this.config.$el;
			} else {
				return this.parent.$el.find(this.config.selector || "#snippet-search");
			}
		},

		/**
		 * @inheritdoc Snippet#render
		 */
		render: function() {
			this.clearInputValues();
            $('.search-input .input-holder').addClass('typing');
            symbolFlag = 0;
            Focus.to(this.getFocusable(0));
		},
        
        search: function() {
            App.throbber();
            searchVar = this.searchInput.getValue();
            searchData = this.getData();
            searchData.then(function(data) {
                var htmlSearch = '';
                try{
                    $('#scene-search-wrapper').slick('unslick');
                } catch(err){}
                $('#scene-search-wrapper').html('');
                
                for (var i = 0; i < data.length; i++) {
                    htmlSearch = htmlSearch + '<div id="search'+(i+1)+'" class="search-thumb-box focusable" data-action="detail" detail-id="' + data[i].id + '">';
                    htmlSearch = htmlSearch + '<img src="' + CONFIG.imageResizerUrl + data[i].thumb_url + '.small.jpg" width="250px">';
                    htmlSearch = htmlSearch + '<div class="label-wrapper">'+ data[i].name.substring(0,40) +'...</div>';
                    htmlSearch = htmlSearch + '</div>';
                }
                $('#title-search').text(__('results')).append(searchVar + '": ').append(data.length);
                
                $('#scene-search-wrapper').html(htmlSearch);
                $('#scene-search-wrapper').slick({
                    infinite: false,
                    draggable: false,
                    slidesToScroll: 1,
                    rows: 3,
                    slidesPerRow: 2,
                    vertical: true,
                    prevArrow: '<div class="slick-prev nav-up" style="left: 45.5%;top: -10px;"></div>',
                    nextArrow: '<div class="slick-next nav-down" style="left: 45.5%; bottom: 45px;"></div>'
                });
                App.throbberHide();
            });
        },
		
        getData: function(){
			return new Promise(function (resolve, reject) {
				API.fetchPlaysSearch(this.searchInput.getValue())
					.bind(this)
					.then(function(data) {
						if (data) {
                            console.log(data.data.videoSearch.data);
                            var detailData = data.data.videoSearch.data;
							resolve(detailData);
						} else {
							console.log("No detail data");
							reject("No detail data");
						}
					})
					.catch(function(err) {
						console.log("Could not get data");
						reject(err);
					});
			}.bind(this))
		},

		clearInputValues: function() {
			this.searchInput.setValue('');
		},

		/**
		 * @inheritdoc Snippet#onClick
		 */
		onClick: function($el, event) {
			if(this.trigger('click', $el, event) === false) {
				return false;
			}
			return this.onEnter.apply(this, arguments);
		},

		/**
		 * @inheritdoc Snippet#onEnter
		 */
		onEnter: function($el, event) {
			var action = $el.attr('data-action');
			this.resetErrors();

			switch(action) {
				case 'search':
                    this.search();
					break;
				case 'back':
                    Router.go('home');
					break;
                case 'backspace':
                    this.searchInput.backspace();
                    break;
                case 'symbol':
                    this.setSymbol();
                    $el.attr('data-action', 'backtoalfabet');
                    $el.html('Aa');
                    break;
                case 'backtoalfabet':
                    this.setAlphabet();
                    $el.attr('data-action', 'symbol');
                    $el.html('!#$');
                    break;
                case 'uppercase':
                    this.setUppercase();
                    $el.attr('data-action', 'lowercase');
                    break;
                case 'lowercase':
                    this.setLowercase();
                    $el.attr('data-action', 'uppercase');
                    break;
                case 'detail':
                    var detailID = $el.attr('detail-id');
                    Router.go('detail', detailID);
                    break;
                case 'input_text':
                    break;
                default:
                    this.searchInput.insert(action);
                    break;
			}

			return false;
		},

		addError: function(error) {
			this.errorField.push(error);
		},

		resetErrors: function() {
			this.errorField = [];
			this.$errorContainer.html('');
		},

		renderError: function(){
			var errorHtml = '<ul id="errors">';
			for(var i = 0, length = this.errorField.length; i < length; i++) {
				errorHtml += '<li class="error">' + __(this.errorField[i]) + '</li>';
			}
			errorHtml += '</ul>';
			this.$errorContainer.html(errorHtml);
		},

		resetHistory: function() {
			console.warn(Router.history);
			Router.history.shift();
			Router.history.shift();
			console.warn(Router.history);
		},

		/**
		 * @inheritdoc Snippet#navigate
		 */
		navigate: function(direction) {
            try {
                var currentSelectedSTR = $('.focus').attr('id');
                var currentSelected = parseInt(currentSelectedSTR.substring(6));
                var currentLevel = currentSelectedSTR.substring(0,6);
            }
            catch(err) {
                console.log(err);
                Focus.to(this.$el.find('#stecla10'));
                return;
            }
            
			switch (direction) {
				case 'up':
                    if (currentLevel == 'stecla') {
					   if (currentSelected > 19)
                        {
                            if (currentSelected == 65){currentSelected -= 1;}
                            Focus.to($('#stecla' + (currentSelected - 10)));
                        }
                    }
                    else if (currentLevel == 'search') {
                        if(currentSelected > 2){
                            if((currentSelected - 1) % 6 == 0 || (currentSelected - 2) % 6 == 0){
                                $('#scene-search-wrapper').slick('slickPrev');
				            }
                            Focus.to($('#search' + (currentSelected - 2)));
                        }
                    }
					break;
				case 'left':
                    if (currentLevel == 'stecla') {
                        if (currentSelected > 10 && currentSelected % 10 > 0)
                        {
                            if (currentSelected == 54){currentSelected -= 3;}
                            if (currentSelected == 58){currentSelected -= 3;}
                            if (currentSelected == 60){currentSelected -= 1;}
                            if (currentSelected == 65){currentSelected = 61;}
                            Focus.to($('#stecla' + (currentSelected - 1)));
                        }
                    }
                    else if (currentLevel == 'search') {
                        if((currentSelected + 1) % 2 == 0){
                            $('.focus').addClass('lastFocused');
                            Focus.to($('#stecla65'));
                        }
                        else if(currentSelected > 0){
                            Focus.to($('#search' + (currentSelected - 1)));
                        }
                    }
					break;
				case 'down':
                    if (currentLevel == 'stecla') {
					   if (currentSelected < 60)
                        {
                            if (currentSelected == 41 || currentSelected == 42){currentSelected = 40;}
                            if (currentSelected == 43 || currentSelected == 45 || currentSelected == 46){currentSelected = 44;}
                            if (currentSelected == 47 || currentSelected == 49){currentSelected = 48;}
                            if (currentSelected == 54 || currentSelected == 58){currentSelected = 55;}
                            Focus.to($('#stecla' + (currentSelected + 10)));
                        }
                    }
                    else if (currentLevel == 'search') {
                        if(currentSelected % 6 == 0 || (currentSelected + 1) % 6 == 0){
                            $('#scene-search-wrapper').slick('slickNext');
				        }
                        Focus.to($('#search' + (currentSelected + 2)));
                    }
					break;
				case 'right':
                    if (currentLevel == 'stecla') {
                        if (currentSelected < 66)
                        {
                            if (currentSelected == 50) {currentSelected += 3;}
                            if (currentSelected == 54) {currentSelected += 3;}
                            if (currentSelected == 60) {currentSelected += 4;}
                            if (currentSelected == 19 || currentSelected == 29 || currentSelected == 39 || currentSelected == 49 || currentSelected == 58 || currentSelected == 65) {
                                if($('.search-thumb-box').hasClass('lastFocused')) {
                                    console.log('Last Focused');
                                    Focus.to($('.lastFocused'));
                                    $('.lastFocused').removeClass('lastFocused');
                                    break;
                                }
                                else if ($('#search1')) {
                                    Focus.to($('#search1'));
                                    $('#scene-search-wrapper').slick('slickGoTo', 0);
                                    break;
                                }
                            }
                            Focus.to($('#stecla' + (currentSelected + 1)));
                        }
                    }
                    else if (currentLevel == 'search') {
                        if(currentSelected % 6 == 0){
                            $('#scene-search-wrapper').slick('slickNext');
				        }
                        Focus.to($('#search' + (currentSelected + 1)));
                    }
					break;
			}
			return false;
		},

		/**
		 * @inheritdoc Snippet#focus
		 */
		focus: function($el) {
			if(!$el) {
				$el = this.getFocusable(0);
			}
			return Focus.to($el);
		},

		/**
		 * @inheritdoc Snippet#focus
		 */
		onFocus: function($el) {
			this.$lastFocused = $el;
		},

		clear: function() {
			this.$lastFocused = null;
		},

		/**
		 * Cascade focus. Manage the process of Focus delegation between snippets inside Snippet
		 *
		 * @param {Object} Snippet or jQuery
		 * @param {String} direction of Focus delegation ("up", "down", "left", "right")
		 */
		onFocusOut: function (snippet, direction) {
		},
        
        setUppercase: function() {
            if(symbolFlag == 1) { this.setAlphabet(); }
            for (i=20;i<48;i++){
                if(i != 40){
                    var vCaracter = $('#stecla'+i).text().toUpperCase();
                    $('#stecla'+i).text(vCaracter);
                    document.getElementById('stecla'+i).setAttribute("data-action", vCaracter);
                }
            }
        },
        setLowercase: function() {
            if(symbolFlag == 1) { this.setAlphabet(); }
            for (i=20;i<48;i++){
                if(i != 40){
                    var vCaracter = $('#stecla'+i).text().toLowerCase();
                    $('#stecla'+i).text(vCaracter);
                    document.getElementById('stecla'+i).setAttribute("data-action", vCaracter);
                }
            }
        },
        setSymbol: function() {
            symbolFlag = 1;
            $('#stecla50').attr('data-action', 'symbol').html('Aa');
            
            $('#stecla20').html('!').attr('data-action', '!');
            $('#stecla21').html('"').attr('data-action', '"');
            $('#stecla22').html('#').attr('data-action', '#');
            $('#stecla23').html('$').attr('data-action', '$');
            $('#stecla24').html('%').attr('data-action', '%');
            $('#stecla25').html('&').attr('data-action', '&');
            $('#stecla26').html('/').attr('data-action', '/');
            $('#stecla27').html('(').attr('data-action', '(');
            $('#stecla28').html(')').attr('data-action', ')');
            $('#stecla29').html('=').attr('data-action', '=');
            $('#stecla30').html('+').attr('data-action', '+');
            $('#stecla31').html('*').attr('data-action', '*');
            $('#stecla32').html('}').attr('data-action', '}');
            $('#stecla33').html('{').attr('data-action', '{');
            $('#stecla34').html(']').attr('data-action', ']');
            $('#stecla35').html('[').attr('data-action', '[');
            $('#stecla36').html(';').attr('data-action', ';');
            $('#stecla37').html(':').attr('data-action', ':');
            $('#stecla38').html('<').attr('data-action', '<');
            $('#stecla39').html('>').attr('data-action', '>');
            $('#stecla41').html('?').attr('data-action', '?');
            $('#stecla42').html('¿').attr('data-action', '¿');
            $('#stecla43').html(',').attr('data-action', ',');
            $('#stecla44').html('£').attr('data-action', '£');
            $('#stecla45').html('€').attr('data-action', '€');
            $('#stecla46').html('|').attr('data-action', '|');
            $('#stecla47').html('°').attr('data-action', '°');
            $('#stecla48').html('@').attr('data-action', '@');
            $('#stecla49').html('-').attr('data-action', '-');
        },
        setAlphabet: function() {
            symbolFlag = 0;
            $('#stecla50').attr('data-action', 'symbol').html('!#$');
            
            $('#stecla20').html('q').attr('data-action', 'q');
            $('#stecla21').html('w').attr('data-action', 'w');
            $('#stecla22').html('e').attr('data-action', 'e');
            $('#stecla23').html('r').attr('data-action', 'r');
            $('#stecla24').html('t').attr('data-action', 't');
            $('#stecla25').html('y').attr('data-action', 'y');
            $('#stecla26').html('u').attr('data-action', 'u');
            $('#stecla27').html('i').attr('data-action', 'i');
            $('#stecla28').html('o').attr('data-action', 'o');
            $('#stecla29').html('p').attr('data-action', 'p');
            $('#stecla30').html('a').attr('data-action', 'a');
            $('#stecla31').html('s').attr('data-action', 's');
            $('#stecla32').html('d').attr('data-action', 'd');
            $('#stecla33').html('f').attr('data-action', 'f');
            $('#stecla34').html('g').attr('data-action', 'g');
            $('#stecla35').html('h').attr('data-action', 'h');
            $('#stecla36').html('j').attr('data-action', 'j');
            $('#stecla37').html('k').attr('data-action', 'k');
            $('#stecla38').html('l').attr('data-action', 'l');
            $('#stecla39').html('ñ').attr('data-action', 'ñ');
            $('#stecla41').html('z').attr('data-action', 'z');
            $('#stecla42').html('x').attr('data-action', 'x');
            $('#stecla43').html('c').attr('data-action', 'c');
            $('#stecla44').html('v').attr('data-action', 'v');
            $('#stecla45').html('b').attr('data-action', 'b');
            $('#stecla46').html('n').attr('data-action', 'n');
            $('#stecla47').html('m').attr('data-action', 'm');
            $('#stecla48').html(',').attr('data-action', ',');
            $('#stecla49').html('.').attr('data-action', '.');
        }
	});

	return Snippet_Search;

})(Snippet);


//////////////////
// WEBPACK FOOTER
// ./js/snippet/search.js
// module id = 75
// module chunks = 0